import React, {useState} from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import {Child, HeaderBtn, HeaderText} from "./HeaderApp.style";
import {BE_ADDR} from "../../api/host";

export const HeaderAppCheck = ({id, logoName, textMessage, downloadHandle, removeHandle, preview = false}) => {
    const [checked, setChecked] = useState(false)
    const changeChecked = (evt) => setChecked(evt.target.checked)
    const isChecked = () => {
        if (checked) {
            const arr = localStorage.getItem("checkList")
                ? JSON.parse(localStorage.getItem("checkList"))
                : []

            arr.push(id)
            localStorage.setItem("checkList", JSON.stringify(arr))
            setChecked(false)
        }
    }

    return <Child>
        {
            logoName && <img
                height={32}
                src={`${BE_ADDR}${logoName}`}
                alt="logo"
            />
        }
        <div style={{
            diplay: "flex",
            flexDirection: "column"
        }}>
            <HeaderText>{textMessage}</HeaderText>
            <div>
                <label
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    htmlFor="check">
                    <input
                        style={{
                            marginRight: "5px"
                        }}
                        id="check"
                        type="checkbox"
                        checked={checked}
                        onChange={changeChecked}
                    />
                    <span>Больше не показывать</span>
                </label>
            </div>
        </div>
        <div style={{display: "flex"}}>
            <HeaderBtn
                onClick={() => {
                    isChecked()
                    downloadHandle()
                }}
            >
                <i className="bi bi-download"/>
                <span>Скачать</span>
            </HeaderBtn>
            <HeaderBtn
                onClick={() => {
                    isChecked()
                    removeHandle()
                }}
            >
                <i className={"bi bi-x-square"}/>
                <span>Закрыть</span>
            </HeaderBtn>
        </div>
    </Child>
}